import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 获取sim卡状态
export function querysimcardinfo (params) {
  params.token = getToken()
  return request({
    url: '/querysimcardinfo',
    method: 'post',
    params
  })
}
// 刷新
export function refreshsimcardinfo () {
  return request({
    url: '/refreshsimcardinfo',
    method: 'post',
    params: { token: getToken() }
  })
}
// 搜索
export function searchsimcard (data) {
  return request({
    url: '/searchsimcard',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// ICCID更新充值时间
export function updatesimcardiccid (data) {
  return request({
    url: '/updatesimcardiccid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 号码更新充值时间
export function updatesimcardphonenum (data) {
  return request({
    url: '/updatesimcardphonenum',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据iccid，批量刷新过期时间
export function refreshsimcardinfobyiccid (data) {
  return request({
    url: '/refreshsimcardinfobyiccid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按照过期日期查找SIM卡信息
export function querysimcardinfobydate (params, data) {
  params.token = getToken()
  return request({
    url: '/querysimcardinfobydate',
    method: 'post',
    params,
    data
  })
}
// 查询当月过期SIM卡信息
export function querysimcardvaliddate (data) {
  return request({
    url: '/querysimcardvaliddate',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/topUp.js